/**
 * Ezoko – laptop cart pop-up (from 990px).
 * Adds a dimmed, blurred layer behind the cart window (click it to close)
 * and a short "… was added to your cart" message after Add to cart.
 * Phones and tablets keep the normal drawer; this script does nothing there.
 */
import { StandardEvents } from '@shopify/events';

if (!window.__ezCartPop) {
  window.__ezCartPop = true;

  const wide = window.matchMedia('(min-width: 990px)');
  const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const getDrawer = () => document.getElementById('cart-drawer');
  let layer = null;

  const setLayer = (on) => {
    if (!layer) {
      layer = document.createElement('div');
      layer.className = 'ezc-ov';
      layer.setAttribute('aria-hidden', 'true');
      layer.addEventListener('click', () => getDrawer()?.close());
      document.body.appendChild(layer);
    }
    layer.classList.toggle('is-on', on && wide.matches);
  };

  document.addEventListener('theme-drawer:open', (e) => { if (e.target && e.target.id === 'cart-drawer') setLayer(true); });
  document.addEventListener('theme-drawer:close', (e) => { if (e.target && e.target.id === 'cart-drawer') setLayer(false); });
  wide.addEventListener('change', () => setLayer(Boolean(getDrawer()?.hasAttribute('open'))));
  if (getDrawer()?.hasAttribute('open')) setLayer(true);

  const showAdded = (title) => {
    const dialog = getDrawer()?.querySelector('dialog');
    if (!dialog || !title) return;
    let el = dialog.querySelector(':scope > .ezc-added');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ezc-added';
      el.setAttribute('role', 'status');
      dialog.appendChild(el);
    }
    el.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8.5 6.5 12 13 4.5"/></svg><span><b></b> ' + (en ? 'is in your cart.' : 'a kosárba került.') + '</span>';
    el.querySelector('b').textContent = title;
    el.classList.remove('is-on');
    void el.offsetWidth;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-on'), 5000);
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, (e) => {
    if (e.action !== 'add' || !e.promise || !wide.matches) return;
    e.promise
      .then(async (result) => {
        if (result && result.detail && result.detail.didError) return;
        const url = ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart') + '.js';
        const cart = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
        const first = cart && cart.items && cart.items[0];
        if (first) showAdded(first.product_title);
      })
      .catch(() => {});
  });
}
